module.exports = __webpack_public_path__ + "img/review_w.4b1c1121.svg";